// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import NavigationList from '../../shared/components/navigation-list';
import offlineReportRoutes from '../../routes/offline-reports';

const OfflineReports = props => {

    const childRoutes = offlineReportRoutes(props.security).childRoutes;

    return childRoutes.length ? (
        <section className='offline-reports'>
            <div className='offline-reports-title'>
                <FormattedMessage id='REPORTS'/>
            </div>
            <div className='offline-reports-body'>
                <NavigationList
                    includeFavorites={false}
                    parentRoute={''}
                    routes={childRoutes}
                />
            </div>
        </section>
    ) : null;

};

OfflineReports.displayName = 'OfflineReports';
OfflineReports.propTypes = {
    security: PropTypes.object.isRequired
};
export default OfflineReports;



// WEBPACK FOOTER //
// ./src/home-page/components/offline-reports.js